import { promotionsResponseSchema } from '@/api/promotions/schemas';
import { apiRequest } from '@/api/utils/api';

export const getPromotions = () =>
  apiRequest({ url: '/promotions', method: 'GET', schema: promotionsResponseSchema });
